import { render, staticRenderFns } from "./UpdateMeContainer.vue?vue&type=template&id=06a16f10"
import script from "./UpdateMeContainer.vue?vue&type=script&lang=js"
export * from "./UpdateMeContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports